import { useAuth as useOidcAuth } from "react-oidc-context"
import { AUTH_DISABLED } from "@/authConfig"

const MOCK_AUTH = {
  isAuthenticated: true,
  isLoading: false,
  user: null,
  error: undefined,
  login: () => Promise.resolve(),
  logout: () => Promise.resolve(),
  removeUser: () => Promise.resolve(),
  getUserKey: () => "system",
} as const

function useOidcAuthWrapper() {
  const auth = useOidcAuth()

  return {
    isAuthenticated: auth.isAuthenticated,
    isLoading: auth.isLoading,
    user: auth.user,
    error: auth.error,
    login: () => auth.signinRedirect(),
    logout: () => auth.signoutRedirect(),
    removeUser: () => auth.removeUser(),
    getUserKey: () => auth.user?.profile?.sub || "system",
  }
}

export const useAuth = AUTH_DISABLED
  ? () => MOCK_AUTH
  : useOidcAuthWrapper
